import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Sparkles, Table2, Heart, LogOut, Shield, Trash2, ChevronRight } from "lucide-react";
import { colors } from "@/theme";
import { SectionTitle } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { toast } from "sonner";

export default function Profile() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const links = [
    { label: "My Orders", to: "/orders", icon: ShoppingBag },
    { label: "Nest Rewards", to: "/points", icon: Sparkles },
    { label: "Nest Tables", to: "/shortlists", icon: Table2 },
    { label: "Wishlist", to: "/wishlist", icon: Heart },
  ];
  if (isAdmin) links.push({ label: "Admin Cockpit", to: "/admin", icon: Shield });

  const del = async () => {
    if (!window.confirm("Permanently delete your account? This cannot be undone.")) return;
    try { await api("/auth/me", { method: "DELETE" }); logout(); toast("Account deleted"); navigate("/"); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px", maxWidth: 720 }}>
      <SectionTitle eyebrow="Account" title="Profile" />
      <div style={{ display: "flex", alignItems: "center", gap: 16, padding: 20, background: colors.surfaceSecondary, borderRadius: 12, marginBottom: 24 }}>
        <div style={{ width: 56, height: 56, borderRadius: 999, background: colors.brand, color: colors.onBrandPrimary, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 700 }} className="font-display">
          {user?.name?.[0]?.toUpperCase()}
        </div>
        <div>
          <div className="font-display" style={{ fontSize: 22, fontWeight: 700 }}>{user?.name}</div>
          <div className="font-body" style={{ color: colors.mutedText, fontSize: 14 }}>{user?.email} · {user?.mobile}</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", border: `1px solid ${colors.border}`, borderRadius: 12, overflow: "hidden" }}>
        {links.map((l) => (
          <Link key={l.to} to={l.to} data-testid={`profile-link-${l.label.toLowerCase().replace(/ /g, "-")}`} style={{ display: "flex", alignItems: "center", gap: 14, padding: "16px 18px", textDecoration: "none", color: colors.onSurface, borderBottom: `1px solid ${colors.border}` }}>
            <l.icon size={19} color={colors.brand} strokeWidth={1.7} />
            <span className="font-body" style={{ fontWeight: 500, flex: 1 }}>{l.label}</span>
            <ChevronRight size={17} color={colors.mutedText} />
          </Link>
        ))}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 24 }}>
        <button data-testid="logout-btn" onClick={() => { logout(); navigate("/"); }} className="btn-outline" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <LogOut size={16} /> Sign Out
        </button>
        <button data-testid="delete-account-btn" onClick={del} style={{ background: "none", border: "none", color: colors.mutedText, cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: 8 }}>
          <Trash2 size={14} /> Delete Account
        </button>
      </div>
    </div>
  );
}
